<template>
  <router-view />
</template>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Outfit&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Outfit&family=Quicksand:wght@500&display=swap");

:root {
  --blue-dark: #253858;
  --gray-lighter: #f5f5f5;
  --gray-light: #dde2e9;
  --gray-dark: #6d7b91;
  --opaque-black: #0004;
}

* {
  font-family: "Outfit", sans-serif;
}

body {
  margin: 0;
}
</style>
